"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.search");
var _RecommendActivityTablePane = _interopRequireDefault(require("./RecommendActivityTablePane.vue"));
var _RecommendActivityConfigPane = _interopRequireDefault(require("./RecommendActivityConfigPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'recommend_activity',
  components: {
    RecommendActivityTablePane: _RecommendActivityTablePane.default,
    RecommendActivityConfigPane: _RecommendActivityConfigPane.default
  },
  data: function data() {
    return {
      activeName: 'table',
      activityId: null
    };
  },
  methods: {
    handleSuccess: function handleSuccess() {
      var _this = this;
      this.activeName = 'table';
      this.activityId = null;
      this.$nextTick(function () {
        if (_this.$refs.recommendActivityTable) {
          _this.$refs.recommendActivityTable.search();
        }
      });
    },
    handleAddActivity: function handleAddActivity() {
      this.activeName = 'config';
      this.activityId = null;
    },
    handleEditActivity: function handleEditActivity(activityId) {
      this.activeName = 'config';
      this.activityId = activityId;
    },
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === 'table') {
        this.activityId = null;
      }
    }
  }
};